import config from '../../config';
const fetchHotelInformation = async (
    hotelId,
    apiKey,
    setFacebookPixelData
) => {
    fetch(
        config.apiEndpoint +
        'bookingEngine/get-hotel-info/' +
        apiKey +
        '/' +
        hotelId,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }
    )
        .then(response => response.json())
        .then(responseJson => {
            if (responseJson.status === 1) {
                sessionStorage.setItem('facebook_pixel_data', JSON.stringify(responseJson.data.facebook_pixel));
                sessionStorage.setItem('google_tag_manager', JSON.stringify(responseJson.data.google_tag_manager));
                setFacebookPixelData(responseJson.data.facebook_pixel);
            }
        })
        .catch(error => { });
};
//Export getAccess
export default fetchHotelInformation;
